import React, { useEffect, useState } from "react";
import { cn } from "~/lib/cn";

export const MarkdownContent = (props: {
  content: string | null | undefined;
  className?: string;
}) => {
  const [html, setHtml] = useState<string | null>(null);

  useEffect(() => {
    const processMarkdown = async () => {
      if (props.content) {
        const { micromark } = await import("micromark");
        setHtml(micromark(props.content));
      } else {
        setHtml(null);
      }
    };
    processMarkdown();
  }, [props.content]);

  return (
    <div
      className={cn("prose", props.className)}
      dangerouslySetInnerHTML={html ? { __html: html } : undefined}
    />
  );
};
